import { useEffect, useState } from 'react';
import { bridge } from 'shared/src/utils';
import { useGoodsSno } from '../../../hooks/useGoodsSno';

export const useLogDisplayRelatedGoods = (params: {
  isSuccess: boolean;
  isLoading: boolean;
  targetList: { logging: { analytics: object; ably_only_log: object } }[];
}) => {
  const goodsSno = useGoodsSno();

  const [logged, setLogged] = useState(false);
  useEffect(() => {
    if (params.isSuccess && params.targetList.length > 0 && !logged) {
      setLogged(true);

      bridge.logAnalyticsEvent({
        name: 'VIEW_DISPLAY_RELATED_GOODS',
        analytics: {
          GOODS_SNO: goodsSno,
        },
      });

      params.targetList.forEach(item => {
        bridge.logAnalyticsEvent({
          name: 'DISPLAY_GOODS',
          channel: ['firebase', 'amplitude', 'ablylog', 'facebook'],
          analytics: { ...item.logging.analytics },
          ably_only_log: { ...item.logging.ably_only_log },
        });
      });
    }
  }, [params, logged, goodsSno]);
};
